import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import { getEngineState } from '../../thunks/vehicleProThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
import { clearVehicleProKey } from '../../thunkKeys/vehicleProThunksKeys';

const SLICE_NAME = 'engineState';

export const engineStateSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearEngineState(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getEngineState });
        builder.addCase(
            clearVehicleProKey,
            () => commonInitialState,
        );
    },
});

export const { clearEngineState } = engineStateSlice.actions;

export const engineState = engineStateSlice.reducer;
